import { Menu } from '@mantine/core'
import PrimaryDropDown from 'app/views/components/DropDown/DropDown'
import { useNavigate } from 'react-router-dom'
import { LoanParams } from 'app/models/loan-params'
import IonIcon from '@reacticons/ionicons'

type Props = {
  row: LoanParams
  /** Lifecycle state of the loan's facility; the servicing feed row carries it. */
  facilityStatus?: string
}

/**
 * "Add Rates" for an approved loan without a base rate: opens the loans tab of
 * its facility. The loan carries the facility id and the feed row its state,
 * so no slice has to be loaded first.
 */
export default function AddRateSettingActions({ row, facilityStatus }: Props) {
  const navigate = useNavigate()

  function navigateToFacility() {
    const facilityId = row.facilityId?.id
    // '' means the feed found no approved facility for the row: nowhere to go
    if (!facilityId || facilityStatus === '') return
    navigate(
      `/dealmanagement/facilities/${facilityId}/${facilityStatus ?? 'Approved'}?tab=loans`,
    )
  }

  return (
    <div>
      <Menu shadow="md" width={200} position="bottom" withinPortal>
        <Menu.Target>
          <div style={{ width: 'fit-content' }}>
            <PrimaryDropDown>Actions</PrimaryDropDown>
          </div>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Item
            icon={<IonIcon className="action-ion-icon" name='swap-horizontal-outline' />}
            onClick={() => navigateToFacility()}
          >
            Add Rates
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </div>
  )
}
